function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4826f;}.cls-2{fill:#fdbf5f;}.cls-3{fill:#fff0a9;}.cls-4{fill:#18a2a4;}.cls-5{fill:#4292cf;}.cls-6{fill:#62c8d5;}.cls-7{fill:#1a78b7;}.cls-8{fill:#fff;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-9{fill:none;stroke-miterlimit:10;}.cls-9{stroke:#fdbf5f;}.cls-10,.cls-14,.cls-9{stroke-width:2px;}.cls-10{stroke:#f4826f;}.cls-11{stroke:#18a2a4;}.cls-12{stroke:#15bab9;}.cls-13{stroke:#1a78b7;}.cls-14{stroke:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_11",
  "data-name": "Layer 11"
}, /*#__PURE__*/React.createElement("g", {
  id: "_Group_",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.2 71.52 41.2 72.51 38.56 73.13 38.56 72.15 41.2 71.52"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "220.38 136.49 245.42 133.02 252.28 132.07 274.05 129.06 280.27 128.2 288.66 127.04 288.66 130.6 214.81 145.76 214.81 137.26 220.38 136.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "288.66 126.49 288.66 127.04 280.27 128.2 280.27 127.43 287.03 126.67 288.66 126.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.66 118.75 288.66 126.49 287.03 126.67 287.03 118.78 288.66 118.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "287.03 118.78 280.27 118.9 280.27 117.64 280.27 117.62 288.66 117.64 288.66 118.75 287.03 118.78"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M622.4,296.81l25,1.92,6.82.52,21.8,1.68,6.22.47,8.39.64v10.73H676.06l-21.77,0h-6.85l-25,0h-5.57V296.38Zm44.19,10.42v-2l-2.65-.13v2.08Zm-29.65-.79v-2.58l-2.72-.2v2.67Z",
  transform: "translate(-402.01 -195.13)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "287.03 105.75 288.66 105.9 288.66 106.91 280.27 106.27 280.27 105.1 287.03 105.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.66 96.05 288.66 105.9 287.03 105.75 287.03 95.8 288.66 96.05"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "287.03 95.8 280.27 94.78 280.27 93.61 288.66 94.99 288.66 96.05 287.03 95.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.66 93.32 288.66 94.99 280.27 93.61 280.27 91.95 288.66 93.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.66 91.69 288.66 93.32 280.27 91.95 280.27 90.27 288.66 91.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.66 90.53 288.66 91.69 280.27 90.27 280.27 89.05 288.66 90.53"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M676.06,283.09l-9.49-1.68v-9.73l11.23,2.63,2.64.61,10.22,2.39v8.35l-8.39-1.48Zm4.38-2.62v-2.23l-2.64-.56v2.25Z",
  transform: "translate(-402.01 -195.13)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.65 81.37 288.65 82.18 278.43 79.79 278.43 78.94 288.65 81.37"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "281.32 78.4 282.21 78.62 285.36 79.37 286.11 79.55 288.65 80.17 288.65 81.37 278.43 78.94 278.43 77.71 281.32 78.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "288.65 71.97 288.65 80.17 286.11 79.55 286.11 71.29 288.65 71.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "282.21 70.25 281.32 70.01 278.43 69.23 278.43 68.19 288.65 70.93 288.65 71.97 286.11 71.29 285.36 71.09 282.21 70.25"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.65 70.07 288.65 70.93 278.43 68.19 278.43 67.3 288.65 70.07"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.65 62.19 288.65 70.07 278.43 67.3 278.43 58.76 288.65 62.19"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "285.31 59.8 288.65 60.93 288.65 62.19 278.43 58.76 278.43 57.49 282.66 58.91 285.31 59.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "288.64 51.96 288.65 60.93 285.31 59.8 285.31 50.75 288.64 51.96"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "288.64 51.12 288.64 51.96 285.31 50.75 285.31 49.87 288.64 51.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.64 50.08 288.64 51.12 285.31 49.87 285.31 48.82 288.64 50.08"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.64 47.5 288.64 50.08 285.31 48.82 285.31 46.16 288.64 47.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "288.64 46.39 288.64 47.5 285.31 46.16 285.31 45.04 288.64 46.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "288.64 42.97 288.64 46.39 285.31 45.04 285.31 41.54 288.64 42.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "288.64 41.95 288.64 42.97 285.31 41.54 285.31 40.5 285.31 40.49 288.64 41.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "287.03 118.78 287.03 126.67 280.27 127.43 280.27 118.9 287.03 118.78"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "287.03 95.8 287.03 105.75 280.27 105.1 280.27 94.78 287.03 95.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "286.11 71.29 286.11 79.55 285.36 79.37 285.36 79.35 285.36 71.09 286.11 71.29"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "285.36 71.09 285.36 79.35 285.36 79.37 282.21 78.62 282.21 70.25 285.36 71.09"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "285.31 40.49 285.31 40.5 285.31 41.54 282.66 40.4 282.66 39.34 285.31 40.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "285.31 50.75 285.31 59.8 282.66 58.91 282.66 58.91 282.66 49.79 285.31 50.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "285.31 49.87 285.31 50.75 282.66 49.79 282.66 48.89 285.31 49.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "285.31 48.82 285.31 49.87 282.66 48.89 282.66 47.83 285.31 48.82"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "285.31 46.16 285.31 48.82 282.66 47.83 282.66 45.09 285.31 46.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "285.31 45.04 285.31 46.16 282.66 45.09 282.66 43.97 285.31 45.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "285.31 41.54 285.31 45.04 282.66 43.97 282.66 40.4 285.31 41.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "282.66 58.91 282.66 58.91 278.43 57.49 278.43 48.25 282.66 49.79 282.66 58.91"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "282.66 48.89 282.66 49.79 278.43 48.25 278.43 47.32 282.66 48.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "282.66 47.83 282.66 48.89 278.43 47.32 278.43 46.23 282.66 47.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "282.66 45.09 282.66 47.83 278.43 46.23 278.43 43.38 282.66 45.09"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "282.66 43.97 282.66 45.09 278.43 43.38 278.43 42.26 282.66 43.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "282.66 40.4 282.66 43.97 278.43 42.26 278.43 38.57 282.66 40.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "282.66 39.34 282.66 40.4 278.43 38.57 278.43 37.54 278.43 31.39 278.47 31.4 278.47 37.51 282.66 39.34"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "282.21 70.25 282.21 78.62 281.32 78.4 281.32 70.01 282.21 70.25"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "281.32 70.01 281.32 78.4 278.43 77.71 278.43 69.23 281.32 70.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "280.27 127.43 280.27 128.2 274.05 129.06 274.05 128.13 280.27 127.43"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "280.27 118.9 280.27 127.43 274.05 128.13 274.05 119.01 280.27 118.9"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "280.27 117.64 280.27 118.9 274.05 119.01 274.05 117.62 274.05 117.61 280.27 117.62 280.27 117.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "280.27 105.1 280.27 106.27 274.05 105.79 274.05 105.78 274.05 104.52 280.27 105.1"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "280.27 94.78 280.27 105.1 274.05 104.52 274.05 93.84 280.27 94.78"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "280.27 93.61 280.27 94.78 274.05 93.84 274.05 92.59 280.27 93.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "280.27 91.95 280.27 93.61 274.05 92.59 274.05 90.95 280.27 91.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "280.27 90.27 280.27 91.95 274.05 90.95 274.05 89.22 280.27 90.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "280.27 89.05 280.27 90.27 274.05 89.22 274.05 87.95 280.27 89.05"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.48 17.58 278.48 18.74 278.43 18.71 278.43 17.55 278.48 17.58"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.48 18.74 278.48 22.59 278.43 22.57 278.43 18.71 278.48 18.74"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.48 22.59 278.48 25.89 278.43 25.87 278.43 22.57 278.48 22.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.48 25.89 278.47 29.89 278.43 29.87 278.43 25.87 278.48 25.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.47 29.89 278.47 31.4 278.43 31.39 278.43 29.87 278.47 29.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 83.11 278.43 85.33 275.79 84.8 275.79 82.55 278.43 83.11"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.43 78.94 278.43 79.79 275.79 79.17 275.79 78.31 278.43 78.94"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 77.71 278.43 78.94 275.79 78.31 275.79 77.07 278.43 77.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.43 69.23 278.43 77.71 275.79 77.07 275.79 68.53 278.43 69.23"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 68.19 278.43 69.23 275.79 68.53 275.79 67.48 278.43 68.19"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.43 67.3 278.43 68.19 275.79 67.48 275.79 66.59 278.43 67.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 58.76 278.43 67.3 275.79 66.59 275.79 57.88 278.43 58.76"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.43 57.49 278.43 58.76 275.79 57.88 275.79 56.59 278.43 57.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 48.25 278.43 57.49 275.79 56.59 275.79 47.3 278.43 48.25"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.43 47.32 278.43 48.25 275.79 47.3 275.79 46.34 278.43 47.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 46.23 278.43 47.32 275.79 46.34 275.79 45.23 278.43 46.23"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 43.38 278.43 46.23 275.79 45.23 275.79 42.31 278.43 43.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.43 42.26 278.43 43.38 275.79 42.31 275.79 41.18 278.43 42.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 38.57 278.43 42.26 275.79 41.18 275.79 37.44 278.43 38.57"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.43 37.54 278.43 38.57 275.79 37.44 275.79 36.4 278.42 37.54 278.43 37.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 31.39 278.43 37.54 278.42 37.54 275.79 36.4 275.79 30.16 278.43 31.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.43 29.87 278.43 31.39 275.79 30.16 275.79 28.65 278.43 29.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 25.87 278.43 29.87 275.79 28.65 275.79 24.61 278.43 25.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.43 22.57 278.43 25.87 275.79 24.61 275.79 21.27 278.43 22.57"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "278.43 18.71 278.43 22.57 275.79 21.27 275.79 17.38 278.43 18.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "278.43 17.55 278.43 18.71 275.79 17.38 275.79 16.14 278.43 17.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "275.79 78.31 275.79 79.17 264.55 76.55 264.55 75.63 275.79 78.31"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "271.88 76.13 272.93 76.38 275.79 77.07 275.79 78.31 264.55 75.63 264.55 74.36 267.69 75.12 268.78 75.38 271.88 76.13"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "275.79 68.53 275.79 77.07 272.93 76.38 272.93 67.78 272.94 67.77 275.79 68.53"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "268.78 66.66 267.7 66.37 264.55 65.53 264.55 64.47 275.79 67.48 275.79 68.53 272.94 67.77 271.88 67.49 268.78 66.66"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "275.79 66.59 275.79 67.48 264.55 64.47 264.55 63.55 275.79 66.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "275.79 57.88 275.79 66.59 264.55 63.55 264.55 54.1 275.79 57.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "271.8 55.25 275.79 56.59 275.79 57.88 264.55 54.1 264.55 52.8 269.16 54.36 271.8 55.25"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "275.79 47.3 275.79 56.59 271.8 55.25 271.8 45.85 275.79 47.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "275.79 46.34 275.79 47.3 271.8 45.85 271.8 44.86 275.79 46.34"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "275.79 45.23 275.79 46.34 271.8 44.86 271.8 43.72 275.79 45.23"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "275.79 42.31 275.79 45.23 271.8 43.72 271.8 40.7 275.79 42.31"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "275.79 41.18 275.79 42.31 271.8 40.7 271.8 39.57 275.79 41.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "275.79 37.44 275.79 41.18 271.8 39.57 271.8 35.72 275.79 37.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "275.79 36.4 275.79 37.44 271.8 35.72 271.8 34.66 275.79 36.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "275.79 30.16 275.79 36.4 271.8 34.66 271.8 28.3 275.79 30.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "275.79 28.65 275.79 30.16 271.8 28.3 271.8 26.8 275.79 28.65"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "275.79 24.61 275.79 28.65 271.8 26.8 271.8 22.71 275.79 24.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "275.79 21.27 275.79 24.61 271.8 22.71 271.8 19.31 275.79 21.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "275.79 17.38 275.79 21.27 271.8 19.31 271.8 15.36 275.79 17.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "275.79 16.14 275.79 17.38 271.8 15.36 271.8 14.06 271.83 14.03 275.79 16.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "266.6 128.96 274.05 128.13 274.05 129.06 252.28 132.07 252.28 130.56 260.05 129.7 266.6 128.96"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "274.05 119.01 274.05 128.13 266.6 128.96 266.6 119.13 274.05 119.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "260.05 119.24 252.28 119.38 252.28 117.58 274.05 117.61 274.05 117.62 274.05 119.01 266.6 119.13 260.05 119.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "266.6 103.81 274.05 104.52 274.05 105.78 274.05 105.79 252.24 104.12 252.25 104.05 252.25 102.45 259.99 103.18 266.6 103.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "274.05 93.84 274.05 104.52 266.6 103.81 266.6 92.77 266.61 92.72 274.05 93.84"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "274.05 92.59 274.05 93.84 266.61 92.72 260 91.71 252.25 90.54 252.25 88.99 274.05 92.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "261.91 88.97 264.54 89.4 274.05 90.95 274.05 92.59 252.25 88.99 252.25 87.4 261.91 88.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "274.05 89.22 274.05 90.95 264.54 89.4 264.55 89.35 264.55 87.6 274.05 89.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "274.05 87.95 274.05 89.22 264.55 87.6 264.55 86.28 274.05 87.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "272.94 67.77 272.93 67.78 272.93 76.38 271.88 76.13 271.88 67.5 271.88 67.49 272.94 67.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "271.88 67.49 271.88 67.5 271.88 76.13 268.78 75.38 268.78 66.66 271.88 67.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "269.25 12.65 271.83 14.03 271.8 14.06 271.8 15.36 269.16 14.03 269.16 12.75 269.25 12.65"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "271.8 45.85 271.8 55.25 269.16 54.36 269.16 44.89 271.8 45.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "271.8 44.86 271.8 45.85 269.16 44.89 269.16 43.88 271.8 44.86"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "271.8 43.72 271.8 44.86 269.16 43.88 269.16 42.73 271.8 43.72"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "271.8 40.7 271.8 43.72 269.16 42.73 269.16 39.64 271.8 40.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "271.8 39.57 271.8 40.7 269.16 39.64 269.16 38.5 271.8 39.57"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "271.8 35.72 271.8 39.57 269.16 38.5 269.16 34.58 271.8 35.72"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "271.8 34.66 271.8 35.72 269.16 34.58 269.16 33.51 271.8 34.66"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "271.8 28.3 271.8 34.66 269.16 33.51 269.16 27.08 271.8 28.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "271.8 26.8 271.8 28.3 269.16 27.08 269.16 25.58 271.8 26.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "271.8 22.71 271.8 26.8 269.16 25.58 269.16 21.46 271.8 22.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "271.8 19.31 271.8 22.71 269.16 21.46 269.16 18.02 271.8 19.31"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "271.8 15.36 271.8 19.31 269.16 18.02 269.16 14.03 271.8 15.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "264.59 10.16 269.25 12.65 269.16 12.75 269.16 14.03 264.55 11.7 264.55 10.21 264.59 10.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "269.16 44.89 269.16 54.36 264.55 52.8 264.55 43.21 269.16 44.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "269.16 43.88 269.16 44.89 264.55 43.21 264.55 42.17 269.16 43.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "269.16 42.73 269.16 43.88 264.55 42.17 264.55 40.98 269.16 42.73"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "269.16 39.64 269.16 42.73 264.55 40.98 264.55 37.77 269.16 39.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "269.16 38.5 269.16 39.64 264.55 37.77 264.55 36.64 269.16 38.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "269.16 34.58 269.16 38.5 264.55 36.64 264.55 32.6 269.16 34.58"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "269.16 33.51 269.16 34.58 264.55 32.6 264.55 31.5 269.16 33.51"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "269.16 27.08 269.16 33.51 264.55 31.5 264.55 24.95 269.16 27.08"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "269.16 25.58 269.16 27.08 264.55 24.95 264.55 23.44 269.16 25.58"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "269.16 21.46 269.16 25.58 264.55 23.44 264.55 19.26 269.16 21.46"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "269.16 18.02 269.16 21.46 264.55 19.26 264.55 15.75 269.16 18.02"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "269.16 14.03 269.16 18.02 264.55 15.75 264.55 11.7 269.16 14.03"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "268.78 66.66 268.78 75.38 267.69 75.12 267.69 66.4 267.7 66.37 268.78 66.66"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "267.7 66.37 267.69 66.4 267.69 75.12 264.55 74.36 264.55 65.53 267.7 66.37"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "260 91.71 266.61 92.72 266.6 92.77 266.6 103.81 259.99 103.18 259.99 91.75 260 91.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "266.6 119.13 266.6 128.96 260.05 129.7 260.05 119.24 266.6 119.13"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "262.01 8.78 264.59 10.16 264.55 10.21 264.55 11.7 261.91 10.36 261.91 8.9 262.01 8.78"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.58 110.08 264.58 112.1 261.93 112.03 261.93 109.94 264.58 110.08"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 87.6 264.55 89.35 264.54 89.4 261.91 88.97 261.91 87.15 264.55 87.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 86.28 264.55 87.6 261.91 87.15 261.91 85.81 264.55 86.28"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 76.55 264.55 86.28 261.91 85.81 261.91 75.93 264.55 76.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 75.63 264.55 76.55 261.91 75.93 261.91 75 264.55 75.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "264.55 74.36 264.55 75.63 261.91 75 261.91 73.72 264.55 74.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 65.53 264.55 74.36 261.91 73.72 261.91 64.83 264.55 65.53"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "264.55 64.47 264.55 65.53 261.91 64.83 261.91 63.75 264.55 64.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 63.55 264.55 64.47 261.91 63.75 261.91 62.84 264.55 63.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 54.1 264.55 63.55 261.91 62.84 261.91 53.21 264.55 54.1"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "264.55 52.8 264.55 54.1 261.91 53.21 261.91 51.91 264.55 52.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 43.21 264.55 52.8 261.91 51.91 261.91 42.26 264.55 43.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "264.55 42.17 264.55 43.21 261.91 42.26 261.91 41.18 264.55 42.17"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 40.98 264.55 42.17 261.91 41.18 261.91 39.98 264.55 40.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 37.77 264.55 40.98 261.91 39.98 261.91 36.7 264.55 37.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "264.55 36.64 264.55 37.77 261.91 36.7 261.91 35.57 264.55 36.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 32.6 264.55 36.64 261.91 35.57 261.91 31.46 264.55 32.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "264.55 31.5 264.55 32.6 261.91 31.46 261.91 30.35 264.55 31.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 24.95 264.55 31.5 261.91 30.35 261.91 23.72 264.55 24.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "264.55 23.44 264.55 24.95 261.91 23.72 261.91 22.22 264.55 23.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 19.26 264.55 23.44 261.91 22.22 261.91 18 264.55 19.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "264.55 15.75 264.55 19.26 261.91 18 261.91 14.46 264.55 15.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "264.55 11.7 264.55 15.75 261.91 14.46 261.91 10.36 264.55 11.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "262.01 8.78 261.91 8.9 261.91 10.36 257.42 8.09 257.42 6.42 257.48 6.36 262.01 8.78"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "261.91 87.15 261.91 88.97 252.25 87.4 252.25 85.52 261.91 87.15"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "261.91 85.81 261.91 87.15 252.25 85.52 252.25 84.14 252.26 84.11 261.91 85.81"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M647.44,278l-10.55-1.87V264.74l12.56,2.93,2.64.62,11.83,2.77v9.88l-9.65-1.7Zm4.65-3.35v-2.44l-2.64-.56v2.46Z",
  transform: "translate(-402.01 -195.13)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "261.91 75 261.91 75.93 250.08 73.16 250.08 72.19 261.91 75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "258.66 72.94 261.91 73.72 261.91 75 250.08 72.19 250.08 70.87 253.01 71.58 254.11 71.84 257.39 72.64 258.66 72.94"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "261.91 64.83 261.91 73.72 258.66 72.94 258.66 63.95 261.91 64.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "257.41 63.62 254.13 62.75 253.03 62.45 250.08 61.66 250.08 60.58 261.91 63.75 261.91 64.83 258.66 63.95 257.41 63.62"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "261.91 62.84 261.91 63.75 250.08 60.58 250.08 59.64 261.91 62.84"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "261.91 53.21 261.91 62.84 250.08 59.64 250.08 49.24 261.91 53.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "257.42 50.4 261.91 51.91 261.91 53.21 250.08 49.24 250.08 47.92 254.78 49.51 257.42 50.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "261.91 42.26 261.91 51.91 257.42 50.4 257.42 40.63 261.91 42.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "261.91 41.18 261.91 42.26 257.42 40.63 257.42 39.52 261.91 41.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "261.91 39.98 261.91 41.18 257.42 39.52 257.42 38.29 261.91 39.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "261.91 36.7 261.91 39.98 257.42 38.29 257.42 34.89 261.91 36.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "261.91 35.57 261.91 36.7 257.42 34.89 257.42 33.75 261.91 35.57"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "261.91 31.46 261.91 35.57 257.42 33.75 257.42 29.52 261.91 31.46"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "261.91 30.35 261.91 31.46 257.42 29.52 257.42 28.4 261.91 30.35"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "261.91 23.72 261.91 30.35 257.42 28.4 257.42 21.64 261.91 23.72"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "261.91 22.22 261.91 23.72 257.42 21.64 257.42 20.14 261.91 22.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "261.91 18 261.91 22.22 257.42 20.14 257.42 15.87 261.91 18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "261.91 14.46 261.91 18 257.42 15.87 257.42 12.26 261.91 14.46"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "261.91 10.36 261.91 14.46 257.42 12.26 257.42 8.09 261.91 10.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "260.05 119.24 260.05 129.7 252.28 130.56 252.28 119.38 260.05 119.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "260 91.71 259.99 91.75 259.99 103.18 252.25 102.45 252.25 90.54 260 91.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "258.66 63.95 258.66 72.94 257.39 72.64 257.41 72.61 257.41 63.62 258.66 63.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "254.9 4.97 257.48 6.36 257.42 6.42 257.42 8.09 254.78 6.76 254.78 5.12 254.9 4.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "257.42 40.63 257.42 50.4 254.78 49.51 254.78 39.67 257.42 40.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "257.42 39.52 257.42 40.63 254.78 39.67 254.78 38.54 257.42 39.52"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "257.42 38.29 257.42 39.52 254.78 38.54 254.78 37.29 257.42 38.29"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "257.42 34.89 257.42 38.29 254.78 37.29 254.78 33.83 257.42 34.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "257.42 33.75 257.42 34.89 254.78 33.83 254.78 32.68 257.42 33.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "257.42 29.52 257.42 33.75 254.78 32.68 254.78 28.38 257.42 29.52"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "257.42 28.4 257.42 29.52 254.78 28.38 254.78 27.25 257.42 28.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "257.42 21.64 257.42 28.4 254.78 27.25 254.78 20.41 257.42 21.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "257.42 20.14 257.42 21.64 254.78 20.41 254.78 18.92 257.42 20.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "257.42 15.87 257.42 20.14 254.78 18.92 254.78 14.61 257.42 15.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "257.42 12.26 257.42 15.87 254.78 14.61 254.78 10.96 257.42 12.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "257.42 8.09 257.42 12.26 254.78 10.96 254.78 6.76 257.42 8.09"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "257.41 63.62 257.41 72.61 257.39 72.64 254.11 71.84 254.13 71.81 254.13 62.75 257.41 63.62"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "254.9 4.97 254.78 5.12 254.78 6.76 250.08 4.38 250.08 2.4 254.9 4.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "254.78 39.67 254.78 49.51 250.08 47.92 250.08 37.97 254.78 39.67"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "254.78 38.54 254.78 39.67 250.08 37.97 250.08 36.79 254.78 38.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "254.78 37.29 254.78 38.54 250.08 36.79 250.08 35.52 254.78 37.29"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "254.78 33.83 254.78 37.29 250.08 35.52 250.08 31.93 254.78 33.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "254.78 32.68 254.78 33.83 250.08 31.93 250.08 30.78 254.78 32.68"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "254.78 28.38 254.78 32.68 250.08 30.78 250.08 26.36 254.78 28.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "254.78 27.25 254.78 28.38 250.08 26.36 250.08 25.2 254.78 27.25"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "254.78 20.41 254.78 27.25 250.08 25.2 250.08 18.23 254.78 20.41"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "254.78 18.92 254.78 20.41 250.08 18.23 250.08 16.74 254.78 18.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "254.78 14.61 254.78 18.92 250.08 16.74 250.08 12.37 254.78 14.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "254.78 10.96 254.78 14.61 250.08 12.37 250.08 8.64 254.78 10.96"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "254.78 6.76 254.78 10.96 250.08 8.64 250.08 4.38 254.78 6.76"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "254.13 62.75 254.13 71.81 254.11 71.84 253.01 71.58 253.03 71.52 253.03 62.45 254.13 62.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "253.03 62.45 253.03 71.52 253.01 71.58 250.08 70.87 250.08 61.66 253.03 62.45"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "252.28 130.56 252.28 132.07 245.42 133.02 245.42 131.33 252.28 130.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "252.28 119.38 252.28 130.56 245.42 131.33 245.42 119.49 252.28 119.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "252.28 117.58 252.28 119.38 245.42 119.49 245.42 117.58 245.42 117.57 252.28 117.58"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "245.42 82.91 252.26 84.11 252.25 84.14 252.25 85.52 245.42 84.35 245.42 82.91"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "252.25 102.45 252.25 104.05 252.24 104.12 245.42 103.59 245.42 103.58 245.42 101.81 252.25 102.45"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "252.25 90.54 252.25 102.45 245.42 101.81 245.42 89.51 252.25 90.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "252.25 88.99 252.25 90.54 245.42 89.51 245.42 87.87 252.25 88.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "252.25 87.4 252.25 88.99 245.42 87.87 245.42 86.3 252.25 87.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "252.25 85.52 252.25 87.4 245.42 86.3 245.42 84.35 252.25 85.52"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 77.12 250.08 79.55 247.43 79.02 247.43 76.56 250.08 77.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "250.08 72.19 250.08 73.16 247.43 72.54 247.43 71.56 250.08 72.19"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 70.87 250.08 72.19 247.43 71.56 247.43 70.23 250.08 70.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "250.08 61.66 250.08 70.87 247.43 70.23 247.43 60.95 250.08 61.66"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 60.58 250.08 61.66 247.43 60.95 247.43 59.87 250.08 60.58"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "250.08 59.64 250.08 60.58 247.43 59.87 247.43 58.92 250.08 59.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 49.24 250.08 59.64 247.43 58.92 247.43 48.35 250.08 49.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "250.08 47.92 250.08 49.24 247.43 48.35 247.43 47.02 250.08 47.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 37.97 250.08 47.92 247.43 47.02 247.43 37 250.08 37.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "250.08 36.79 250.08 37.97 247.43 37 247.42 35.81 250.08 36.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 35.52 250.08 36.79 247.42 35.81 247.42 34.52 250.08 35.52"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 31.93 250.08 35.52 247.42 34.52 247.42 30.85 250.08 31.93"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "250.08 30.78 250.08 31.93 247.42 30.85 247.42 29.7 250.08 30.78"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 26.36 250.08 30.78 247.42 29.7 247.42 25.21 250.08 26.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "250.08 25.2 250.08 26.36 247.42 25.21 247.42 24.05 250.08 25.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 18.23 250.08 25.2 247.42 24.05 247.45 24 247.51 24.03 247.5 17.03 250.08 18.23"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "250.08 16.74 250.08 18.23 247.5 17.03 247.49 15.55 250.08 16.74"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 12.37 250.08 16.74 247.49 15.55 247.48 11.13 250.08 12.37"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "250.08 8.64 250.08 12.37 247.48 11.13 247.48 7.37 250.08 8.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "250.08 4.38 250.08 8.64 247.48 7.37 247.47 3.06 250.08 4.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "250.08 2.4 250.08 4.38 247.47 3.06 247.46 1 250.08 2.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "247.48 11.13 247.49 15.55 247.5 17.03 247.51 24.03 247.45 24 243.14 22.13 240.36 20.92 234.91 18.55 232.21 17.38 232.18 17.39 168.35 33.56 168.35 33.56 168.35 33.7 168.32 33.7 165.71 32.93 165.72 32.91 165.72 23.9 195.77 15.48 209.93 11.52 247.46 1 247.47 3.06 247.48 7.37 247.48 11.13"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "247.45 24 247.42 24.05 247.42 25.21 243.05 23.33 243.05 22.27 243.14 22.13 247.45 24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "247.43 71.56 247.43 72.54 234.87 69.61 234.87 68.56 247.43 71.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "238.09 67.98 239.41 68.31 243.09 69.19 244.39 69.5 247.43 70.23 247.43 71.56 234.87 68.56 234.87 67.21 238.09 67.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "247.43 60.95 247.43 70.23 244.39 69.5 244.39 60.15 247.43 60.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "239.41 58.81 238.1 58.46 234.87 57.6 234.87 56.5 247.43 59.87 247.43 60.95 244.39 60.15 243.11 59.8 239.41 58.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "247.43 58.92 247.43 59.87 234.87 56.5 234.87 55.53 247.43 58.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "247.43 48.35 247.43 58.92 234.87 55.53 234.87 44.14 247.43 48.35"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "247.43 47.02 247.43 48.35 234.87 44.14 234.87 42.79 240.35 44.64 243.05 45.55 247.43 47.02"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "247.43 37 247.43 47.02 243.05 45.55 243.05 45.54 243.05 35.42 247.43 37"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "247.42 35.81 247.43 37 243.05 35.42 243.05 34.18 247.42 35.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "247.42 35.81 243.05 34.18 243.05 32.87 247.42 34.52 247.42 35.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "247.42 30.85 247.42 34.52 243.05 32.87 243.05 29.09 247.42 30.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "247.42 29.7 247.42 30.85 243.05 29.09 243.05 27.93 247.42 29.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "247.42 25.21 247.42 29.7 243.05 27.93 243.05 23.33 247.42 25.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "236.76 132.31 245.42 131.33 245.42 133.02 220.38 136.49 220.38 134.14 230.08 133.05 236.76 132.31"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "245.42 119.49 245.42 131.33 236.76 132.31 236.76 119.64 245.42 119.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "230.08 119.76 220.38 119.92 220.38 117.6 220.38 117.53 245.42 117.57 245.42 117.58 245.42 119.49 236.76 119.64 230.08 119.76"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "236.76 100.99 245.42 101.81 245.42 103.58 245.42 103.59 220.38 101.67 220.38 99.44 230.06 100.35 236.76 100.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "245.42 89.51 245.42 101.81 236.76 100.99 236.76 88.25 236.78 88.2 245.42 89.51"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "245.42 87.87 245.42 89.51 236.78 88.2 230.06 87.19 220.38 85.72 220.38 83.75 245.42 87.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "245.42 86.3 245.42 87.87 220.38 83.75 220.38 80.11 232.18 82.11 232.18 84.14 234.87 84.58 245.42 86.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "245.42 84.35 245.42 86.3 234.87 84.58 232.18 84.14 234.87 84.58 234.87 82.56 245.42 84.35"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "245.42 82.91 245.42 84.35 234.87 82.56 234.87 81.04 245.42 82.91"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "244.39 60.15 244.39 69.5 243.09 69.19 243.09 59.83 243.11 59.8 244.39 60.15"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "243.14 22.13 243.05 22.27 243.05 23.33 240.36 22.17 240.36 20.92 243.14 22.13"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "239.41 58.81 243.11 59.8 243.09 59.83 243.09 69.19 239.41 68.31 239.41 58.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "243.05 35.42 243.05 45.54 243.05 45.55 240.35 44.64 240.36 44.62 240.36 34.44 243.05 35.42"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "243.05 34.18 243.05 35.42 240.36 34.44 240.36 33.18 243.05 34.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "243.05 32.87 243.05 34.18 240.36 33.18 240.36 31.85 243.05 32.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "243.05 29.09 243.05 32.87 240.36 31.85 240.36 28.01 243.05 29.09"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "243.05 27.93 243.05 29.09 240.36 28.01 240.36 26.84 243.05 27.93"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "243.05 23.33 243.05 27.93 240.36 26.84 240.36 22.17 243.05 23.33"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "240.36 34.44 240.36 44.62 240.35 44.64 234.87 42.79 234.87 32.45 240.36 34.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "240.36 33.18 240.36 34.44 234.87 32.45 234.87 31.15 240.36 33.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "240.36 31.85 240.36 33.18 234.87 31.15 234.87 29.77 240.36 31.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "240.36 28.01 240.36 31.85 234.87 29.77 234.87 25.79 240.36 28.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "240.36 26.84 240.36 28.01 234.87 25.79 234.87 24.62 240.36 26.84"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "240.36 22.17 240.36 26.84 234.87 24.62 234.87 19.8 240.36 22.17"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "240.36 20.92 240.36 22.17 234.87 19.8 234.87 18.6 234.91 18.55 240.36 20.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "239.41 58.81 239.41 68.31 238.09 67.98 238.09 58.47 238.1 58.46 239.41 58.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "238.1 58.46 238.09 58.47 238.09 67.98 234.87 67.21 234.87 57.6 238.1 58.46"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "236.78 88.2 236.76 88.25 236.76 100.99 230.06 100.35 230.06 100.32 230.06 87.2 230.06 87.19 236.78 88.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "236.76 119.64 236.76 132.31 230.08 133.05 230.08 119.76 236.76 119.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.92 108.73 234.92 111.3 232.21 111.2 232.21 108.53 234.92 108.73"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "234.91 18.55 234.87 18.6 234.87 19.8 232.31 18.7 232.21 18.7 232.21 17.38 234.91 18.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 82.56 234.87 84.58 232.18 84.14 232.18 82.11 234.87 82.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 81.04 234.87 82.56 232.18 82.11 232.18 80.56 234.87 81.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 69.61 234.87 81.04 232.18 80.56 232.18 68.98 234.87 69.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 68.56 234.87 69.61 232.18 68.98 232.18 67.92 234.87 68.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "234.87 67.21 234.87 68.56 232.18 67.92 232.18 66.56 234.87 67.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 57.6 234.87 67.21 232.18 66.56 232.18 56.88 234.87 57.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "234.87 56.5 234.87 57.6 232.18 56.88 232.18 55.78 234.87 56.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 55.53 234.87 56.5 232.18 55.78 232.18 54.8 234.87 55.53"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 44.14 234.87 55.53 232.18 54.8 232.18 43.23 234.87 44.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "234.87 42.79 234.87 44.14 232.18 43.23 232.18 41.95 232.21 41.96 232.21 41.89 234.87 42.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 32.45 234.87 42.79 232.21 41.89 232.21 31.52 232.31 31.52 234.87 32.45"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "234.87 31.15 234.87 32.45 232.31 31.52 232.21 31.52 232.21 30.2 232.31 30.2 234.87 31.15"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 29.77 234.87 31.15 232.31 30.2 232.21 30.2 232.21 28.82 232.36 28.82 234.87 29.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 25.79 234.87 29.77 232.36 28.82 232.21 28.82 232.21 24.75 232.31 24.75 234.87 25.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "234.87 24.62 234.87 25.79 232.31 24.75 232.21 24.75 232.21 23.56 232.24 23.56 234.87 24.62"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "234.87 19.8 234.87 24.62 232.24 23.56 232.21 23.56 232.21 18.7 232.31 18.7 234.87 19.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "232.21 41.89 232.21 41.96 232.18 41.95 232.18 41.88 232.21 41.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "232.21 31.52 232.21 41.89 232.18 41.88 232.18 17.39 232.21 17.38 232.21 18.7 232.21 23.56 232.21 24.75 232.21 28.82 232.21 30.2 232.21 31.52"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "232.18 80.56 232.18 82.11 220.38 80.11 220.38 78.49 232.18 80.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "217.66 65.58 232.18 68.98 232.18 80.56 220.38 78.49 214.81 77.5 214.81 72.22 217.66 72.81 217.66 70.21 214.81 69.6 214.81 64.92 217.66 65.58"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "232.18 67.92 232.18 68.98 217.66 65.58 217.66 64.47 232.18 67.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "228.38 65.64 232.18 66.56 232.18 67.92 217.66 64.47 217.66 63.06 221.55 64 223.08 64.37 226.86 65.28 228.38 65.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "232.18 56.88 232.18 66.56 228.38 65.64 228.38 55.87 232.18 56.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "228.38 55.87 226.89 55.47 223.09 54.46 221.58 54.05 217.66 53.01 217.66 51.88 232.18 55.78 232.18 56.88 228.38 55.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "232.18 54.8 232.18 55.78 217.66 51.88 217.66 50.88 232.18 54.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "232.18 43.23 232.18 54.8 217.66 50.88 217.66 38.36 232.18 43.23"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "232.18 41.95 232.18 43.23 217.66 38.36 217.66 36.99 218.02 37.11 232.18 41.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "232.18 41.88 232.18 41.95 218.02 37.11 232.18 41.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "217.66 36.98 214.81 36.01 214.78 36.01 176.41 44.5 176.39 44.5 176.39 44.45 168.35 42.3 168.35 33.7 168.35 33.56 168.35 33.56 232.18 17.39 232.18 41.88 218.02 37.11 217.66 36.99 217.66 36.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "230.08 119.76 230.08 133.05 220.38 134.14 220.38 119.92 230.08 119.76"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "230.06 87.2 230.06 100.32 230.06 100.35 220.38 99.44 220.38 85.72 230.06 87.19 230.06 87.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "228.38 55.87 228.38 65.64 226.86 65.28 226.88 65.24 226.88 55.48 226.89 55.47 228.38 55.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "226.89 55.47 226.88 55.48 226.88 65.24 226.86 65.28 223.08 64.37 223.08 54.47 223.09 54.46 226.89 55.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "223.09 54.46 223.08 54.47 223.08 64.37 221.55 64 221.57 63.94 221.57 54.07 221.58 54.05 223.09 54.46"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "217.66 53.01 221.58 54.05 221.57 54.07 221.57 63.94 221.55 64 217.66 63.06 217.66 53.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "220.38 134.14 220.38 136.49 214.81 137.26 214.81 134.77 220.38 134.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "220.38 119.92 220.38 134.14 214.81 134.77 214.81 120.02 220.38 119.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "220.38 117.6 220.38 119.92 214.81 120.02 214.81 117.52 220.38 117.53 220.38 117.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "220.38 99.44 220.38 101.67 214.81 101.25 214.81 98.91 220.38 99.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "220.38 85.72 220.38 99.44 214.81 98.91 214.81 84.89 220.38 85.72"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "220.38 83.75 220.38 85.72 214.81 84.89 214.81 83.09 216.41 83.09 220.38 83.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "220.38 80.11 220.38 83.75 216.41 83.09 214.81 83.09 214.81 79.16 220.38 80.11"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "220.38 78.49 220.38 80.11 214.81 79.16 214.81 77.5 220.38 78.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "217.66 70.21 217.66 72.81 214.81 72.22 214.81 69.6 217.66 70.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "217.66 64.47 217.66 65.58 214.81 64.92 214.81 63.79 217.66 64.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "217.66 63.06 217.66 64.47 214.81 63.79 214.81 62.5 214.81 62.38 217.66 63.06"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "217.66 53.01 217.66 63.06 214.81 62.38 214.81 52.27 214.92 52.27 217.66 53.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "217.66 51.88 217.66 53.01 214.92 52.27 214.81 52.27 214.81 51.14 214.9 51.14 217.66 51.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "217.66 50.88 217.66 51.88 214.9 51.14 214.81 51.14 214.81 50.1 217.66 50.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "217.66 38.36 217.66 50.88 214.81 50.1 214.81 37.4 217.66 38.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "217.66 36.99 217.66 38.36 214.81 37.4 214.81 36.02 217.66 36.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "217.66 36.98 217.66 36.99 214.81 36.02 214.81 36.01 217.66 36.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "214.81 120.02 214.81 134.77 214.81 137.26 214.81 145.76 183.44 151.61 183.44 98.8 214.81 101.65 214.81 117.52 214.81 120.02"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "214.81 101.25 214.81 101.65 183.44 98.8 183.68 54.75 214.81 62.5 214.81 63.79 214.81 64.92 214.81 69.6 214.79 69.6 214.81 72.22 214.81 72.22 214.81 77.5 214.81 79.16 214.81 83.09 214.81 84.89 214.81 98.91 214.81 101.25"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "214.81 69.6 214.81 72.22 214.81 72.22 214.79 69.6 214.81 69.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "214.81 50.1 214.81 51.14 214.81 52.27 214.81 62.38 214.81 62.5 183.68 54.75 176.39 53.01 176.39 44.5 176.41 44.5 214.78 36.01 214.81 36.02 214.81 37.4 214.81 50.1"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "214.81 36.01 214.81 36.02 214.78 36.01 214.81 36.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "209.85 11.35 209.93 11.52 195.77 15.48 195.77 5.07 209.85 11.35"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "165.72 23.9 165.65 23.92 165.65 23.94 160.75 22.35 160.75 16.79 195.77 5.07 195.77 15.48 165.72 23.9"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "176.39 53.01 183.68 54.75 183.44 98.8 144.34 95.13 144.32 45.36 144.34 45.35 176.39 53.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "183.44 98.8 183.44 151.61 143.12 151.55 166.69 151.55 166.69 151.51 169.31 151.51 169.31 116.7 151.69 116.7 137.1 116.7 119.42 116.7 119.42 151.51 122.03 151.51 122.03 151.52 113.79 151.51 104.95 151.49 104.95 98.71 183.44 98.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "183.44 98.8 104.95 98.71 144.34 95.13 183.44 98.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "168.35 42.3 176.39 44.45 176.39 44.5 176.39 53.01 144.34 45.35 144.32 45.36 144.32 35.89 144.34 35.89 168.35 42.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "169.31 116.7 169.31 151.51 166.69 151.51 166.69 127 166.27 127 166.27 123.04 151.69 123.04 151.69 118.02 151.69 116.7 169.31 116.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "168.35 33.7 168.35 42.3 144.34 35.89 144.32 35.89 144.31 26.61 144.34 26.6 165.71 32.93 168.32 33.7 168.35 33.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "166.69 151.51 166.69 151.55 143.12 151.55 122.03 151.52 122.03 151.51 122.54 151.51 137.1 151.51 151.69 151.51 166.27 151.51 166.69 151.51"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 166.27,
  y: 127,
  width: 0.42,
  height: 24.51
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M568.29,322.13v24.51H553.71V322.13ZM566.18,343V324.45H555.83V343Z",
  transform: "translate(-402.01 -195.13)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 151.69,
  y: 123.04,
  width: 14.58,
  height: 3.95
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "165.65 23.94 165.65 23.92 165.72 23.9 165.72 32.91 165.71 32.93 144.34 26.6 144.31 26.61 144.31 17.04 144.34 17.05 160.75 22.35 165.65 23.94"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 153.82,
  y: 129.32,
  width: 10.35,
  height: 18.55
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "160.75 16.79 160.75 22.35 144.34 17.05 144.34 10.59 160.75 16.79"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M553.71,346.57v.07H539.12V322.13h14.59ZM551.59,343V324.45H541.24V343Z",
  transform: "translate(-402.01 -195.13)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 137.1,
  y: 123.04,
  width: 14.59,
  height: 3.95
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "151.69 118.02 151.69 123.04 137.1 123.04 137.1 118.02 137.1 116.7 151.69 116.7 151.69 118.02"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 139.22,
  y: 129.32,
  width: 10.35,
  height: 18.55
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "144.34 10.59 144.34 17.05 144.31 17.04 144.3 17.04 127.34 22.52 127.34 16.75 144.34 10.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "144.32 45.36 144.34 95.13 104.95 98.71 104.95 54.77 104.95 54.77 105.89 54.55 112.87 52.88 144.32 45.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "144.32 35.89 144.32 45.36 112.87 52.88 112.87 44.36 112.87 44.35 112.86 44.31 120.7 42.22 144.32 35.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "144.31 26.61 144.32 35.89 120.7 42.22 120.69 42.21 120.69 33.57 120.7 33.57 122.95 32.91 144.31 26.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "123.01 23.92 127.34 22.52 144.3 17.04 144.31 17.04 144.31 26.61 122.95 32.91 122.95 23.89 123 23.91 123.01 23.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "143.12 151.55 122.03 151.55 122.03 151.52 143.12 151.55"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M539.12,346.57v.07H524.55V322.13h14.57ZM537,343V324.45H526.65V343Z",
  transform: "translate(-402.01 -195.13)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 122.54,
  y: 123.04,
  width: 14.57,
  height: 3.95
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "137.1 118.02 137.1 123.04 122.54 123.04 122.54 127 122.03 127 122.03 151.51 119.42 151.51 119.42 116.7 137.1 116.7 137.1 118.02"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 124.64,
  y: 129.32,
  width: 10.35,
  height: 18.55
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "122.95 23.89 93.53 15.64 93.33 5.02 127.34 16.75 127.34 22.52 123.01 23.92 123 23.91 122.95 23.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.18 3.03 41.17 1 41.22 0.96 78.41 11.4 93.53 15.64 122.95 23.89 122.95 32.91 120.7 33.57 120.69 33.57 120.67 33.57 56.45 17.34 53.74 18.53 48.27 20.92 45.51 22.13 41.22 24.01 41.2 16.97 41.2 15.48 41.2 11.08 41.19 7.32 41.18 3.03"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 122.03,
  y: 127,
  width: 0.51,
  height: 24.51
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "73.94 35.75 73.85 35.98 70.97 36.95 56.45 41.85 56.45 18.67 56.45 17.34 120.67 33.57 120.69 33.57 120.69 42.21 120.7 42.22 112.86 44.31 112.87 44.35 112.87 44.36 73.94 35.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "73.85 37.36 73.85 35.98 73.94 35.75 112.87 44.36 112.87 52.88 105.89 54.55 104.95 54.77 103.93 55.02 73.85 62.25 73.85 52.24 73.85 51.11 73.85 50.07 73.85 37.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "73.83 134.73 73.84 120.2 73.84 117.93 73.84 101.56 104.95 98.71 104.95 151.49 73.83 145.87 73.83 137.23 73.83 134.73"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "73.85 64.88 73.85 63.74 73.85 62.25 103.93 55.02 104.95 54.77 104.95 98.71 73.84 101.56 73.84 101.21 73.84 98.87 73.84 79.12 73.84 77.46 73.84 69.57 73.85 64.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "104.95 54.77 104.95 54.77 103.93 55.02 104.95 54.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "93.33 5.02 93.53 15.64 78.41 11.4 93.33 5.02"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "73.85 37.36 73.85 50.07 70.97 50.85 70.97 38.33 73.85 37.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.85 35.98 73.85 37.36 70.97 38.33 70.97 36.95 73.85 35.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.85 50.07 73.85 51.11 73.72 51.11 70.97 51.85 70.97 50.85 73.85 50.07"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "73.85 51.11 73.85 52.24 73.72 52.24 70.97 52.98 70.97 51.85 73.72 51.11 73.85 51.11"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.85 52.24 73.85 62.25 73.83 62.26 73.83 62.39 73.64 62.39 70.97 63.03 70.97 52.98 73.72 52.24 73.85 52.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.83 134.73 73.83 137.23 68.25 136.45 68.25 134.11 73.83 134.73"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "68.25 136.45 73.83 137.23 73.83 145.87 0 130.61 0 127 8.37 128.16 14.59 129.03 36.36 132.04 43.21 132.99 68.25 136.45"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.83 120.2 73.83 134.73 68.25 134.11 68.25 120.11 73.83 120.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.83 117.93 73.83 120.2 68.25 120.11 68.25 117.94 73.83 117.93"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M470.27,296.77l5.58-.43v16.72h-5.58l-25,0h-6.86l-21.77,0H402V302l8.37-.64,6.22-.48,21.81-1.67,6.82-.53Zm-11.83,9.53v-2.67l-2.71.2v2.57Zm-29.73.83V305l-2.64.13v2Z",
  transform: "translate(-402.01 -195.13)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.83 98.87 73.83 101.21 68.25 101.64 68.25 99.4 73.83 98.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.83 84.9 73.83 98.87 68.25 99.4 68.25 85.69 73.48 84.9 73.83 84.9"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.83 82.86 73.83 84.9 73.48 84.9 68.25 85.69 68.25 83.71 73.46 82.86 73.83 82.86"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.83 79.12 73.83 82.86 73.46 82.86 68.25 83.71 68.25 80.07 73.83 79.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "73.83 77.47 73.83 79.12 68.25 80.07 68.25 78.45 73.83 77.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "70.97 65.55 73.83 64.88 73.83 69.57 70.97 70.18 70.97 72.77 73.83 72.18 73.83 77.47 68.25 78.45 56.45 80.53 56.45 68.95 70.97 65.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "73.83 69.57 73.83 72.18 70.97 72.77 70.97 70.18 73.83 69.57"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "73.83 63.75 73.83 64.88 70.97 65.55 70.97 64.43 73.83 63.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "73.83 62.39 73.83 63.75 70.97 64.43 70.97 63.03 73.64 62.39 73.83 62.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "70.97 64.43 70.97 65.55 56.45 68.95 56.45 67.89 70.97 64.43"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "60.25 65.61 61.77 65.25 65.55 64.33 67.09 63.96 70.97 63.03 70.97 64.43 56.45 67.89 56.45 66.53 60.25 65.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "70.97 52.98 70.97 63.03 67.09 63.96 67.07 63.9 67.07 54.04 67.06 54.02 70.97 52.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "60.25 55.83 56.45 56.85 56.45 55.74 70.97 51.85 70.97 52.98 67.06 54.02 65.55 54.42 61.74 55.44 60.25 55.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "70.97 50.85 70.97 51.85 56.45 55.74 56.45 54.77 70.97 50.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "70.97 38.33 70.97 50.85 56.45 54.77 56.45 43.2 70.97 38.33"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "70.97 36.95 70.97 38.33 56.45 43.2 56.45 41.86 70.97 36.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "70.97 36.95 56.45 41.86 56.45 41.85 70.97 36.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "51.87 132.27 58.56 133.02 68.25 134.11 68.25 136.45 43.21 132.99 43.21 131.3 51.87 132.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "68.25 120.11 68.25 134.11 58.56 133.02 58.56 119.94 68.25 120.11"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "51.87 119.83 43.21 119.67 43.21 117.97 68.25 117.94 68.25 120.11 58.56 119.94 51.87 119.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "51.87 100.95 58.58 100.31 68.25 99.4 68.25 101.64 43.21 103.56 43.21 103.54 43.21 101.77 51.87 100.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "68.25 85.69 68.25 99.4 58.58 100.31 58.57 100.29 58.57 87.16 58.57 87.16 68.25 85.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "68.25 83.71 68.25 85.69 58.57 87.16 51.86 88.17 43.21 89.47 43.21 87.84 68.25 83.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "68.25 80.07 68.25 83.71 43.21 87.84 43.21 86.26 53.76 84.55 56.45 84.11 56.45 82.08 68.25 80.07"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "68.25 78.45 68.25 80.07 56.45 82.08 56.45 80.53 68.25 78.45"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "67.07 63.9 67.09 63.96 65.55 64.33 65.55 54.44 65.55 54.42 67.06 54.02 67.07 54.04 67.07 63.9"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "65.55 54.44 65.55 64.33 61.77 65.25 61.75 65.2 61.75 55.45 61.74 55.44 65.55 54.42 65.55 54.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "61.75 65.2 61.77 65.25 60.25 65.61 60.25 55.83 61.74 55.44 61.75 55.45 61.75 65.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "60.25 55.83 60.25 65.61 56.45 66.53 56.45 56.85 60.25 55.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.57 100.29 58.58 100.31 51.87 100.95 51.87 88.21 51.86 88.17 58.57 87.16 58.57 87.16 58.57 100.29"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.56 119.94 58.56 133.02 51.87 132.27 51.87 119.83 58.56 119.94"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 82.08 56.45 84.11 53.76 84.54 53.76 82.53 56.45 82.08"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 80.53 56.45 82.08 53.76 82.53 53.76 81.01 56.45 80.53"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 68.95 56.45 80.53 53.76 81.01 53.76 69.58 56.45 68.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 67.89 56.45 68.95 53.76 69.58 53.76 68.53 56.45 67.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "56.45 66.53 56.45 67.89 53.76 68.53 53.76 67.18 56.45 66.53"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 56.85 56.45 66.53 53.76 67.18 53.76 57.57 56.45 56.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "56.45 55.74 56.45 56.85 53.76 57.57 53.76 56.47 56.45 55.74"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 54.77 56.45 55.74 53.76 56.47 53.76 55.5 56.45 54.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 43.2 56.45 54.77 53.76 55.5 53.76 44.1 56.45 43.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "56.45 41.86 56.45 43.2 53.76 44.1 53.76 42.76 56.43 41.86 56.43 41.87 56.45 41.86"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 41.85 56.45 41.86 56.43 41.87 56.43 41.86 56.45 41.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 18.67 56.45 41.85 56.43 41.86 56.44 31.48 56.44 30.16 56.44 28.79 56.45 24.72 56.45 23.53 56.45 18.67"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "56.45 17.34 56.45 18.67 56.32 18.67 53.76 19.77 53.76 18.57 53.74 18.53 56.45 17.34"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 18.67 56.45 23.53 56.39 23.53 53.76 24.59 53.76 19.77 56.32 18.67 56.45 18.67"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "56.45 84.11 53.76 84.55 43.21 86.26 43.21 84.32 53.76 82.53 53.76 84.54 56.45 84.11"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "56.45 23.53 56.45 24.72 56.32 24.72 53.76 25.75 53.76 24.59 56.39 23.53 56.45 23.53"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.45 24.72 56.44 28.79 56.28 28.79 53.76 29.74 53.76 25.75 56.32 24.72 56.45 24.72"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.44 28.79 56.44 30.16 56.32 30.16 53.76 31.11 53.76 29.74 56.28 28.79 56.44 28.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "56.44 30.16 56.44 31.48 56.32 31.48 53.76 32.41 53.76 31.11 56.32 30.16 56.44 30.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.44 31.48 56.43 41.86 53.76 42.76 53.76 32.41 56.32 31.48 56.44 31.48"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "56.43 108.49 56.43 111.16 53.71 111.26 53.71 108.69 56.43 108.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "53.76 81.01 53.76 82.53 43.21 84.32 43.21 82.87 53.76 81.01"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M445.23,278l-6.84,1.2-9.66,1.71V271l11.84-2.77,15.21-3.55v11.43Zm-2-3.88v-2.46l-2.65.56v2.43Z",
  transform: "translate(-402.01 -195.13)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "53.76 68.53 53.76 69.58 38.56 73.13 41.2 72.51 41.2 71.52 53.76 68.53"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "50.55 67.95 53.76 67.18 53.76 68.53 41.2 71.52 41.2 70.21 44.24 69.47 45.54 69.16 49.23 68.27 50.55 67.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "53.76 57.57 53.76 67.18 50.55 67.95 50.55 58.44 50.54 58.43 53.76 57.57"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "44.24 60.12 41.2 60.93 41.2 59.84 53.76 56.47 53.76 57.57 50.54 58.43 49.23 58.78 45.53 59.77 44.24 60.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "53.76 55.5 53.76 56.47 41.2 59.84 41.2 58.89 53.76 55.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "53.76 44.1 53.76 55.5 41.2 58.89 41.2 48.32 53.76 44.1"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "53.76 42.76 53.76 44.1 41.2 48.32 41.21 47 45.59 45.52 48.29 44.61 53.76 42.76"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "53.76 32.41 53.76 42.76 48.29 44.61 48.27 44.59 48.27 34.4 53.76 32.41"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "53.76 31.11 53.76 32.41 48.27 34.4 48.27 33.14 53.76 31.11"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "53.76 29.74 53.76 31.11 48.27 33.14 48.27 31.82 53.76 29.74"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "53.76 25.75 53.76 29.74 48.27 31.82 48.27 27.97 53.76 25.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "53.76 24.59 53.76 25.75 48.27 27.97 48.27 26.81 53.76 24.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "53.76 19.77 53.76 24.59 48.27 26.81 48.27 22.14 53.76 19.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "53.76 18.57 53.76 19.77 48.27 22.14 48.27 20.92 53.74 18.53 53.76 18.57"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "51.87 119.83 51.87 132.27 43.21 131.3 43.21 119.67 51.87 119.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "51.87 88.21 51.87 100.95 43.21 101.77 43.21 89.47 51.86 88.17 51.87 88.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "50.55 58.44 50.55 67.95 49.23 68.27 49.23 58.78 50.54 58.43 50.55 58.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "49.23 58.78 49.23 68.27 45.54 69.16 45.54 59.8 45.53 59.77 49.23 58.78"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "48.27 44.59 48.29 44.61 45.59 45.52 45.58 45.51 45.58 35.38 48.27 34.4 48.27 44.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "48.27 33.14 48.27 34.4 45.58 35.38 45.58 34.14 48.27 33.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "48.27 31.82 48.27 33.14 45.58 34.14 45.58 32.83 48.27 31.82"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "48.27 27.97 48.27 31.82 45.58 32.83 45.58 29.06 48.27 27.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "48.27 26.81 48.27 27.97 45.58 29.06 45.58 27.9 48.27 26.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "48.27 22.14 48.27 26.81 45.58 27.9 45.58 23.3 48.27 22.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "48.27 20.92 48.27 22.14 45.58 23.3 45.58 22.23 45.51 22.13 48.27 20.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "45.59 45.52 41.21 47 41.21 36.97 45.58 35.38 45.58 45.51 45.59 45.52"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "45.58 34.14 45.58 35.38 41.21 36.97 41.21 35.77 45.58 34.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "45.58 32.83 45.58 34.14 41.21 35.77 41.21 34.48 45.58 32.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "45.58 29.06 45.58 32.83 41.21 34.48 41.22 30.82 45.58 29.06"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "45.58 27.9 45.58 29.06 41.22 30.82 41.22 29.67 45.58 27.9"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "45.58 23.3 45.58 27.9 41.22 29.67 41.22 25.18 45.58 23.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "45.58 22.23 45.58 23.3 41.22 25.18 41.22 24.01 45.51 22.13 45.58 22.23"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "45.54 59.8 45.54 69.16 44.24 69.47 44.24 60.12 45.53 59.77 45.54 59.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "44.24 60.12 44.24 69.47 41.2 70.21 41.2 60.93 44.24 60.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "43.21 131.3 43.21 132.99 36.36 132.04 36.36 130.53 43.21 131.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "43.21 119.67 43.21 131.3 36.36 130.53 36.36 119.56 43.21 119.67"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "43.21 117.97 43.21 119.67 36.36 119.56 36.36 117.98 43.21 117.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "43.21 103.54 43.21 103.56 36.39 104.09 36.39 104.01 36.39 102.42 43.21 101.77 43.21 103.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "43.21 89.47 43.21 101.77 36.39 102.42 36.39 90.51 43.21 89.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "43.21 87.84 43.21 89.47 36.39 90.51 36.39 88.96 43.21 87.84"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "43.21 86.26 43.21 87.84 36.39 88.96 36.39 87.37 43.21 86.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "43.21 84.32 43.21 86.26 36.39 87.37 36.39 85.48 43.21 84.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "43.21 82.87 43.21 84.32 36.39 85.48 36.39 84.11 36.37 84.07 43.21 82.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.2 16.97 41.22 24.01 38.56 25.17 38.56 18.2 41.2 16.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.22 24.01 41.22 25.18 38.56 26.32 38.56 25.17 41.22 24.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.22 25.18 41.22 29.67 38.56 30.74 38.56 26.32 41.22 25.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.22 29.67 41.22 30.82 38.56 31.89 38.56 30.74 41.22 29.67"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.22 30.82 41.21 34.48 38.56 35.48 38.56 31.89 41.22 30.82"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.21 34.48 41.21 35.77 38.56 36.76 38.56 35.48 41.21 34.48"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.21 35.77 41.21 36.97 38.56 37.93 38.56 36.76 41.21 35.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.21 36.97 41.21 47 38.56 47.89 38.56 37.93 41.21 36.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.21 47 41.2 48.32 38.56 49.21 38.56 47.89 41.21 47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.2 48.32 41.2 58.89 38.56 59.61 38.56 49.21 41.2 48.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.2 15.48 41.2 16.97 38.56 18.2 38.56 16.7 41.2 15.48"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.2 76.53 41.2 78.98 38.56 79.52 38.56 77.09 41.2 76.53"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.2 58.89 41.2 59.84 38.56 60.55 38.56 59.61 41.2 58.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.2 59.84 41.2 60.93 38.56 61.63 38.56 60.55 41.2 59.84"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.2 11.08 41.2 15.48 38.56 16.7 38.56 12.33 41.19 11.08 41.2 11.08"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.2 60.93 41.2 70.21 38.56 70.84 38.56 61.63 41.2 60.93"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.2 70.21 41.2 71.52 38.56 72.15 38.56 70.84 41.2 70.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.19 7.32 41.2 11.08 41.19 11.08 38.56 12.33 38.56 8.61 41.19 7.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "41.18 3.03 41.19 7.32 38.56 8.61 38.56 4.35 41.18 3.03"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.17 1 41.18 3.03 38.56 4.35 38.56 2.4 41.17 1"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.56 72.15 38.56 73.13 26.72 75.9 26.72 74.97 38.56 72.15"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "29.98 72.91 31.24 72.6 34.52 71.81 35.62 71.55 38.56 70.84 38.56 72.15 26.72 74.97 26.72 73.69 29.98 72.91"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "38.56 61.63 38.56 70.84 35.62 71.55 35.59 71.49 35.59 62.42 38.56 61.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "34.51 62.71 31.23 63.59 29.98 63.92 26.72 64.79 26.72 63.73 38.56 60.55 38.56 61.63 35.59 62.42 34.51 62.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.56 59.61 38.56 60.55 26.72 63.73 26.72 62.81 38.56 59.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.56 49.21 38.56 59.61 26.72 62.81 26.72 53.18 38.56 49.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "33.86 49.47 38.56 47.89 38.56 49.21 26.72 53.18 26.72 51.88 31.21 50.37 33.86 49.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "38.56 37.93 38.56 47.89 33.86 49.47 33.86 39.64 38.56 37.93"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "38.56 36.76 38.56 37.93 33.86 39.64 33.86 38.5 38.56 36.76"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.56 35.48 38.56 36.76 33.86 38.5 33.86 37.26 38.56 35.48"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.56 31.89 38.56 35.48 33.86 37.26 33.86 33.79 38.56 31.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.56 30.74 38.56 31.89 33.86 33.79 33.86 32.65 38.56 30.74"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "38.56 26.32 38.56 30.74 33.86 32.65 33.86 28.35 38.56 26.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "38.56 25.17 38.56 26.32 33.86 28.35 33.86 27.21 38.56 25.17"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "38.56 18.2 38.56 25.17 33.86 27.21 33.86 20.38 38.56 18.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.56 16.7 38.56 18.2 33.86 20.38 33.86 18.88 38.56 16.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "38.56 12.33 38.56 16.7 33.86 18.88 33.86 14.57 38.56 12.33"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "38.56 8.61 38.56 12.33 33.86 14.57 33.86 10.92 38.56 8.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "38.56 4.35 38.56 8.61 33.86 10.92 33.86 6.72 38.56 4.35"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.56 2.4 38.56 4.35 33.86 6.72 33.86 5.08 33.76 4.97 38.56 2.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "28.64 103.14 36.39 102.42 36.39 104.01 36.39 104.09 14.59 105.76 14.59 105.75 14.59 104.48 22.04 103.77 28.64 103.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "36.39 90.51 36.39 102.42 28.64 103.14 28.64 91.71 28.63 91.68 36.39 90.51"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "36.39 88.96 36.39 90.51 28.63 91.68 22.02 92.68 14.59 93.81 14.59 92.55 36.39 88.96"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.72 88.94 36.39 87.37 36.39 88.96 14.59 92.55 14.59 90.91 24.1 89.36 26.72 88.94"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "36.39 85.48 36.39 87.37 26.72 88.94 26.72 87.12 36.39 85.48"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "36.39 84.11 36.39 85.48 26.72 87.12 26.72 85.78 36.37 84.07 36.39 84.11"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "22.04 128.92 28.59 129.66 36.36 130.53 36.36 132.04 14.59 129.03 14.59 128.09 22.04 128.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "36.36 119.56 36.36 130.53 28.59 129.66 28.59 119.43 36.36 119.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "22.04 119.32 14.59 119.19 14.59 118.02 36.36 117.98 36.36 119.56 28.59 119.43 22.04 119.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "35.59 71.49 35.62 71.55 34.52 71.81 34.51 71.77 34.51 62.71 35.59 62.42 35.59 71.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "34.51 71.77 34.52 71.81 31.24 72.6 31.23 72.57 31.23 63.59 34.51 62.71 34.51 71.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "33.86 39.64 33.86 49.47 31.21 50.37 31.21 40.6 33.86 39.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "33.86 38.5 33.86 39.64 31.21 40.6 31.21 39.48 33.86 38.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "33.86 37.26 33.86 38.5 31.21 39.48 31.21 38.26 33.86 37.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "33.86 33.79 33.86 37.26 31.21 38.26 31.21 34.86 33.86 33.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "33.86 32.65 33.86 33.79 31.21 34.86 31.21 33.72 33.86 32.65"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "33.86 28.35 33.86 32.65 31.21 33.72 31.21 29.49 33.86 28.35"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "33.86 27.21 33.86 28.35 31.21 29.49 31.21 28.36 33.86 27.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "33.86 20.38 33.86 27.21 31.21 28.36 31.21 21.61 33.86 20.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "33.86 18.88 33.86 20.38 31.21 21.61 31.21 20.11 33.86 18.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "33.86 14.57 33.86 18.88 31.21 20.11 31.21 15.83 33.86 14.57"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "33.86 10.92 33.86 14.57 31.21 15.83 31.21 12.22 33.86 10.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "33.86 6.72 33.86 10.92 31.21 12.22 31.21 8.06 33.86 6.72"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "33.86 5.08 33.86 6.72 31.21 8.06 31.21 6.39 31.18 6.34 33.76 4.97 33.86 5.08"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "31.23 72.57 31.24 72.6 29.98 72.91 29.98 63.92 31.23 63.59 31.23 72.57"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "31.21 40.6 31.21 50.37 26.72 51.88 26.72 42.22 31.21 40.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "31.21 39.48 31.21 40.6 26.72 42.22 26.72 41.15 31.21 39.48"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "31.21 38.26 31.21 39.48 26.72 41.15 26.72 39.96 31.21 38.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "31.21 34.86 31.21 38.26 26.72 39.96 26.72 36.67 31.21 34.86"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "31.21 33.72 31.21 34.86 26.72 36.67 26.72 35.54 31.21 33.72"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "31.21 29.49 31.21 33.72 26.72 35.54 26.72 31.42 31.21 29.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "31.21 28.36 31.21 29.49 26.72 31.42 26.72 30.32 31.21 28.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "31.21 21.61 31.21 28.36 26.72 30.32 26.72 23.69 31.21 21.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "31.21 20.11 31.21 21.61 26.72 23.69 26.72 22.19 31.21 20.11"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "31.21 15.83 31.21 20.11 26.72 22.19 26.72 17.97 31.21 15.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "31.21 12.22 31.21 15.83 26.72 17.97 26.72 14.42 31.21 12.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "31.21 8.06 31.21 12.22 26.72 14.42 26.72 10.33 31.21 8.06"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "31.21 6.39 31.21 8.06 26.72 10.33 26.72 8.87 26.64 8.77 31.18 6.34 31.21 6.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "29.98 63.92 29.98 72.91 26.72 73.69 26.72 64.79 29.98 63.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "28.64 91.71 28.64 103.14 22.04 103.77 22.04 92.73 22.02 92.68 28.63 91.68 28.64 91.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "28.59 119.43 28.59 129.66 22.04 128.92 22.04 119.32 28.59 119.43"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 87.12 26.72 88.94 24.1 89.36 24.08 89.32 24.08 87.57 26.72 87.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 85.78 26.72 87.12 24.08 87.57 24.08 86.24 26.72 85.78"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 75.9 26.72 85.78 24.08 86.24 24.08 76.51 26.72 75.9"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 74.97 26.72 75.9 24.08 76.51 24.08 75.6 26.72 74.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.72 73.69 26.72 74.97 24.08 75.6 24.08 74.33 26.72 73.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 64.79 26.72 73.69 24.08 74.33 24.08 65.5 26.72 64.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.72 63.73 26.72 64.79 24.08 65.5 24.08 64.43 26.72 63.73"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 62.81 26.72 63.73 24.08 64.43 24.08 63.52 26.72 62.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 53.18 26.72 62.81 24.08 63.52 24.08 54.06 26.72 53.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.72 51.88 26.72 53.18 24.08 54.06 24.08 52.77 26.72 51.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 42.22 26.72 51.88 24.08 52.77 24.08 43.18 26.72 42.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.72 41.15 26.72 42.22 24.08 43.18 24.08 42.13 26.72 41.15"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 39.96 26.72 41.15 24.08 42.13 24.08 40.95 26.72 39.96"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 36.67 26.72 39.96 24.08 40.95 24.08 37.74 26.72 36.67"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.72 35.54 26.72 36.67 24.08 37.74 24.08 36.6 26.72 35.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 31.42 26.72 35.54 24.08 36.6 24.08 32.56 26.72 31.42"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.72 30.32 26.72 31.42 24.08 32.56 24.08 31.47 26.72 30.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 23.69 26.72 30.32 24.08 31.47 24.08 24.91 26.72 23.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.72 22.19 26.72 23.69 24.08 24.91 24.08 23.41 26.72 22.19"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 17.97 26.72 22.19 24.08 23.41 24.08 19.22 26.72 17.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.72 14.42 26.72 17.97 24.08 19.22 24.08 15.72 26.72 14.42"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.72 10.33 26.72 14.42 24.08 15.72 24.08 11.66 26.72 10.33"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.72 8.87 26.72 10.33 24.08 11.66 24.08 10.18 24.06 10.15 26.64 8.77 26.72 8.87"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "26.7 109.91 26.7 111.99 24.06 112.07 24.06 110.04 26.7 109.91"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "24.08 89.32 24.1 89.36 14.59 90.91 14.59 89.18 24.08 87.57 24.08 89.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "24.08 86.24 24.08 87.57 14.59 89.18 14.59 87.92 24.08 86.24"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M416.6,283.05l-6.22,1.09L402,285.62v-8.35l10.21-2.38,2.64-.62,11.24-2.62v9.72Zm-1.74-3.15v-2.25l-2.64.56v2.22Z",
  transform: "translate(-402.01 -195.13)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "24.08 75.6 24.08 76.51 12.85 79.14 12.85 78.28 24.08 75.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "16.76 76.09 19.85 75.34 20.94 75.08 24.08 74.33 24.08 75.6 12.85 78.28 12.85 77.03 15.7 76.35 16.76 76.09"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "24.08 65.5 24.08 74.33 20.94 75.08 20.94 66.36 20.93 66.34 24.08 65.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "19.85 66.63 16.75 67.45 15.69 67.73 12.85 68.5 12.85 67.45 24.08 64.43 24.08 65.5 20.93 66.34 19.85 66.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "24.08 63.52 24.08 64.43 12.85 67.45 12.85 66.56 24.08 63.52"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "24.08 54.06 24.08 63.52 12.85 66.56 12.85 57.84 24.08 54.06"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "16.83 55.22 19.47 54.32 24.08 52.77 24.08 54.06 12.85 57.84 12.85 56.56 16.83 55.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "24.08 43.18 24.08 52.77 19.47 54.32 19.47 44.86 24.08 43.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "24.08 42.13 24.08 43.18 19.47 44.86 19.47 43.84 24.08 42.13"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "24.08 40.95 24.08 42.13 19.47 43.84 19.47 42.69 24.08 40.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "24.08 37.74 24.08 40.95 19.47 42.69 19.47 39.6 24.08 37.74"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "24.08 36.6 24.08 37.74 19.47 39.6 19.47 38.47 24.08 36.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "24.08 32.56 24.08 36.6 19.47 38.47 19.47 34.55 24.08 32.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "24.08 31.47 24.08 32.56 19.47 34.55 19.47 33.48 24.08 31.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "24.08 24.91 24.08 31.47 19.47 33.48 19.47 27.05 24.08 24.91"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "24.08 23.41 24.08 24.91 19.47 27.05 19.47 25.55 24.08 23.41"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "24.08 19.22 24.08 23.41 19.47 25.55 19.47 21.43 24.08 19.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "24.08 15.72 24.08 19.22 19.47 21.43 19.47 17.98 24.08 15.72"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "24.08 11.66 24.08 15.72 19.47 17.98 19.47 13.99 24.08 11.66"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "24.08 10.18 24.08 11.66 19.47 13.99 19.47 12.71 19.4 12.64 24.06 10.15 24.08 10.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "22.04 119.32 22.04 128.92 14.59 128.09 14.59 119.19 22.04 119.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "22.04 92.73 22.04 103.77 14.59 104.48 14.59 93.81 22.02 92.68 22.04 92.73"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "20.94 66.36 20.94 75.08 19.85 75.34 19.85 66.63 20.93 66.34 20.94 66.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "19.85 66.63 19.85 75.34 16.76 76.09 16.76 67.47 16.75 67.45 19.85 66.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.47 44.86 19.47 54.32 16.83 55.22 16.83 45.81 19.47 44.86"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "19.47 43.84 19.47 44.86 16.83 45.81 16.83 44.83 19.47 43.84"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.47 42.69 19.47 43.84 16.83 44.83 16.83 43.69 19.47 42.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "19.47 39.6 19.47 42.69 16.83 43.69 16.83 40.67 19.47 39.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "19.47 38.47 19.47 39.6 16.83 40.67 16.83 39.54 19.47 38.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "19.47 34.55 19.47 38.47 16.83 39.54 16.83 35.69 19.47 34.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.47 33.48 19.47 34.55 16.83 35.69 16.83 34.63 19.47 33.48"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "19.47 27.05 19.47 33.48 16.83 34.63 16.83 28.28 19.47 27.05"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.47 25.55 19.47 27.05 16.83 28.28 16.83 26.77 19.47 25.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "19.47 21.43 19.47 25.55 16.83 26.77 16.83 22.68 19.47 21.43"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.47 17.98 19.47 21.43 16.83 22.68 16.83 19.28 19.47 17.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "19.47 13.99 19.47 17.98 16.83 19.28 16.83 15.33 19.47 13.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.47 12.71 19.47 13.99 16.83 15.33 16.83 14.03 16.82 14.01 19.4 12.64 19.47 12.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "16.83 45.81 16.83 55.22 12.85 56.56 12.85 47.26 16.83 45.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "16.83 44.83 16.83 45.81 12.85 47.26 12.85 46.3 16.83 44.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "16.83 43.69 16.83 44.83 12.85 46.3 12.85 45.19 16.83 43.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "16.83 40.67 16.83 43.69 12.85 45.19 12.85 42.27 16.83 40.67"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "16.83 39.54 16.83 40.67 12.85 42.27 12.85 41.15 16.83 39.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "16.83 35.69 16.83 39.54 12.85 41.15 12.85 37.4 16.83 35.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "16.83 34.63 16.83 35.69 12.85 37.4 12.85 36.36 16.83 34.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "16.83 28.28 16.83 34.63 12.85 36.36 12.85 30.12 16.83 28.28"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "16.83 26.77 16.83 28.28 12.85 30.12 12.85 28.61 16.83 26.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "16.83 22.68 16.83 26.77 12.85 28.61 12.85 24.58 16.83 22.68"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "16.83 19.28 16.83 22.68 12.85 24.58 12.85 21.24 16.83 19.28"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "16.83 15.33 16.83 19.28 12.85 21.24 12.85 17.34 16.83 15.33"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "16.83 14.03 16.83 15.33 12.85 17.34 12.85 16.14 16.82 14.01 16.83 14.03"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "16.76 67.47 16.76 76.09 15.7 76.35 15.7 67.75 15.69 67.73 16.75 67.45 16.76 67.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "15.7 67.75 15.7 76.35 12.85 77.03 12.85 68.5 15.69 67.73 15.7 67.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "14.59 128.09 14.59 129.03 8.37 128.16 8.37 127.39 14.59 128.09"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "14.59 119.19 14.59 128.09 8.37 127.39 8.37 119.08 14.59 119.19"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "14.59 118.02 14.59 119.19 8.37 119.08 8.37 118.03 14.59 118.02"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "14.59 105.75 14.59 105.76 8.37 106.24 8.37 105.06 14.59 104.48 14.59 105.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "14.59 93.81 14.59 104.48 8.37 105.06 8.37 94.75 14.59 93.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "14.59 92.55 14.59 93.81 8.37 94.75 8.37 93.57 14.59 92.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "14.59 90.91 14.59 92.55 8.37 93.57 8.37 91.92 14.59 90.91"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "14.59 89.18 14.59 90.91 8.37 91.92 8.37 90.24 14.59 89.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "14.59 87.92 14.59 89.18 8.37 90.24 8.37 89.01 14.59 87.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 82.52 12.85 84.76 10.21 85.3 10.21 83.08 12.85 82.52"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.85 78.28 12.85 79.14 10.21 79.76 10.21 78.9 12.85 78.28"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 77.03 12.85 78.28 10.21 78.9 10.21 77.67 12.85 77.03"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.85 68.5 12.85 77.03 10.21 77.67 10.21 69.2 12.85 68.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 67.45 12.85 68.5 10.21 69.2 10.21 68.16 12.85 67.45"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.85 66.56 12.85 67.45 10.21 68.16 10.21 67.27 12.85 66.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 57.84 12.85 66.56 10.21 67.27 10.21 58.73 12.85 57.84"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.85 56.56 12.85 57.84 10.21 58.73 10.21 57.45 12.85 56.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 47.26 12.85 56.56 10.21 57.45 10.21 48.22 12.85 47.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.85 46.3 12.85 47.26 10.21 48.22 10.21 47.28 12.85 46.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 45.19 12.85 46.3 10.21 47.28 10.21 46.2 12.85 45.19"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 42.27 12.85 45.19 10.21 46.2 10.21 43.34 12.85 42.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.85 41.15 12.85 42.27 10.21 43.34 10.21 42.22 12.85 41.15"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 37.4 12.85 41.15 10.21 42.22 10.21 38.54 12.85 37.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.85 36.36 12.85 37.4 10.21 38.54 10.21 37.51 10.21 37.51 12.85 36.36"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 30.12 12.85 36.36 10.21 37.51 10.21 31.35 12.85 30.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.85 28.61 12.85 30.12 10.21 31.35 10.21 29.83 12.85 28.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 24.58 12.85 28.61 10.21 29.83 10.21 25.83 12.85 24.58"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.85 21.24 12.85 24.58 10.21 25.83 10.21 22.52 12.85 21.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "12.85 17.34 12.85 21.24 10.21 22.52 10.21 18.67 12.85 17.34"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12.85 16.14 12.85 17.34 10.21 18.67 10.21 17.55 12.85 16.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "10.21 78.9 10.21 79.76 0 82.14 0 81.33 10.21 78.9"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "6.42 78.59 7.31 78.37 10.21 77.67 10.21 78.9 0 81.33 0 80.13 2.52 79.52 3.28 79.34 6.42 78.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "10.21 69.2 10.21 77.67 7.31 78.37 7.31 69.97 10.21 69.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "7.31 69.97 6.42 70.21 3.27 71.05 2.52 71.26 0 71.93 0 70.9 10.21 68.16 10.21 69.2 7.31 69.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "10.21 67.27 10.21 68.16 0 70.9 0 70.03 10.21 67.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "10.21 58.73 10.21 67.27 0 70.03 0 62.16 10.21 58.73"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "3.33 59.77 5.97 58.88 10.21 57.45 10.21 58.73 0 62.16 0 60.89 3.33 59.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "10.21 48.22 10.21 57.45 5.97 58.88 5.97 58.88 5.97 49.76 10.21 48.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "10.21 47.28 10.21 48.22 5.97 49.76 5.97 48.86 10.21 47.28"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "10.21 46.2 10.21 47.28 5.97 48.86 5.97 47.79 10.21 46.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "10.21 43.34 10.21 46.2 5.97 47.79 5.97 45.05 10.21 43.34"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "10.21 42.22 10.21 43.34 5.97 45.05 5.97 43.93 10.21 42.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "10.21 38.54 10.21 42.22 5.97 43.93 5.97 40.37 10.21 38.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "10.21 37.51 10.21 38.54 5.97 40.37 5.97 39.35 10.21 37.51"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "1.6 126.63 8.37 127.39 8.37 128.16 0 127 0 126.45 1.6 126.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "8.37 119.08 8.37 127.39 1.6 126.63 1.6 118.96 8.37 119.08"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "1.6 118.96 0 118.93 0 118.04 8.37 118.03 8.37 119.08 1.6 118.96"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "1.6 105.71 8.37 105.06 8.37 106.24 0 106.88 0 105.86 1.6 105.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "8.37 94.75 8.37 105.06 1.6 105.71 1.6 95.77 8.37 94.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "1.6 95.77 0 96.01 0 94.95 8.37 93.57 8.37 94.75 1.6 95.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "8.37 91.92 8.37 93.57 0 94.95 0 93.28 8.37 91.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "8.37 90.24 8.37 91.92 0 93.28 0 91.66 8.37 90.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "8.37 89.01 8.37 90.24 0 91.66 0 90.49 8.37 89.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "7.31 69.97 7.31 78.37 6.42 78.59 6.42 70.21 7.31 69.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "6.42 70.21 6.42 78.59 3.28 79.34 3.27 79.32 3.27 71.05 6.42 70.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "5.97 58.88 5.97 58.88 3.33 59.77 3.33 50.71 5.97 49.76 5.97 58.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "5.97 48.86 5.97 49.76 3.33 50.71 3.33 49.84 5.97 48.86"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "5.97 47.79 5.97 48.86 3.33 49.84 3.33 48.79 5.97 47.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "5.97 45.05 5.97 47.79 3.33 48.79 3.33 46.12 5.97 45.05"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "5.97 43.93 5.97 45.05 3.33 46.12 3.33 45.01 5.97 43.93"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "5.97 40.37 5.97 43.93 3.33 45.01 3.33 41.51 5.97 40.37"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "5.97 39.35 5.97 40.37 3.33 41.51 3.33 40.51 5.97 39.35"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "3.33 50.71 3.33 59.77 0 60.89 0 51.92 3.33 50.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "3.33 49.84 3.33 50.71 0 51.92 0 51.08 3.33 49.84"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "3.33 48.79 3.33 49.84 0 51.08 0 50.05 3.33 48.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "3.33 46.12 3.33 48.79 0 50.05 0 47.46 3.33 46.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "3.33 45.01 3.33 46.12 0 47.46 0 46.35 3.33 45.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "3.33 41.51 3.33 45.01 0 46.35 0 42.94 3.33 41.51"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "3.33 40.51 3.33 41.51 0 42.94 0 41.96 3.33 40.51"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "3.27 79.32 3.28 79.34 2.52 79.52 2.52 71.26 3.27 71.05 3.27 79.32"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "2.52 71.26 2.52 79.52 0 80.13 0 71.93 2.52 71.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "1.6 118.96 1.6 126.63 0 126.45 0 118.93 1.6 118.96"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "1.6 95.77 1.6 105.71 0 105.86 0 96.01 1.6 95.77"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Group_2",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("line", {
  className: "cls-9",
  x1: 214.94,
  y1: 36.27,
  x2: 176.41,
  y2: 44.5
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-9",
  x1: 232.35,
  y1: 17.65,
  x2: 168.35,
  y2: 33.56
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "247.46 1 165.72 23.9 165.65 23.92"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 73.67,
  y1: 36.27,
  x2: 112.87,
  y2: 44.36
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 56.28,
  y1: 17.61,
  x2: 120.67,
  y2: 33.57
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-10",
  points: "41.22 0.96 122.95 23.89 123 23.91"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-10",
  points: "112.87 52.88 112.87 44.36 112.87 44.35"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-9",
  x1: 176.39,
  y1: 53.02,
  x2: 176.39,
  y2: 44.45
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 120.69,
  y1: 42.21,
  x2: 120.69,
  y2: 33.55
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-9",
  x1: 168.35,
  y1: 42.35,
  x2: 168.35,
  y2: 33.56
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-10",
  points: "122.95 32.91 122.95 23.89 122.95 23.85"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "165.72 23.85 165.72 23.9 165.72 32.91"
})), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 166.44,
  y1: 96.74,
  x2: 166.44,
  y2: 50.69
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 175.68,
  y1: 97.34,
  x2: 175.68,
  y2: 53.54
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 155.67,
  y1: 95.54,
  x2: 155.67,
  y2: 48.59
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 144.68,
  y1: 58,
  x2: 214.21,
  y2: 71.86
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 144.68,
  y1: 70.19,
  x2: 213.98,
  y2: 81.5
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 144.68,
  y1: 82.68,
  x2: 214.36,
  y2: 91.49
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 192.68,
  y1: 149.46,
  x2: 192.68,
  y2: 57.07
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 200.29,
  y1: 148.72,
  x2: 200.29,
  y2: 58.7
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 207.28,
  y1: 147,
  x2: 207.28,
  y2: 61.2
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 161.53,
  y1: 30.71,
  x2: 161.53,
  y2: 22.83
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 150.25,
  y1: 27.66,
  x2: 150.25,
  y2: 19.37
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 155.98,
  y1: 29.18,
  x2: 155.98,
  y2: 21.3
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 151.4,
  y1: 37.34,
  x2: 151.4,
  y2: 29.05
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 157.12,
  y1: 38.86,
  x2: 157.12,
  y2: 30.98
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 162.68,
  y1: 40.39,
  x2: 162.68,
  y2: 32.51
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 154.07,
  y1: 47.84,
  x2: 154.07,
  y2: 39
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 161.78,
  y1: 49.87,
  x2: 161.78,
  y2: 41.03
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 169.16,
  y1: 51.73,
  x2: 169.16,
  y2: 42.89
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 144.77,
  y1: 22.26,
  x2: 164.88,
  y2: 28.22
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 144.66,
  y1: 32.75,
  x2: 168.32,
  y2: 39.29
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 144.65,
  y1: 43.04,
  x2: 176.45,
  y2: 50.88
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 148.98,
  y1: 18.49,
  x2: 148.98,
  y2: 12.71
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 153.39,
  y1: 19.73,
  x2: 153.39,
  y2: 14.19
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 157.35,
  y1: 21.42,
  x2: 157.35,
  y2: 15.57
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 144.7,
  y1: 15.06,
  x2: 160.84,
  y2: 20.67
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 183.78,
  y1: 109.63,
  x2: 213.32,
  y2: 111.17
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 183.34,
  y1: 119.94,
  x2: 213.96,
  y2: 120.09
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 183.74,
  y1: 130.69,
  x2: 213.51,
  y2: 128.68
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 183.41,
  y1: 141.05,
  x2: 213.28,
  y2: 136.79
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 166.44,
  y1: 96.74,
  x2: 166.44,
  y2: 50.69
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 175.68,
  y1: 97.34,
  x2: 175.68,
  y2: 53.54
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 155.67,
  y1: 95.54,
  x2: 155.67,
  y2: 48.59
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 144.68,
  y1: 58,
  x2: 214.21,
  y2: 71.86
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 144.68,
  y1: 70.19,
  x2: 213.98,
  y2: 81.5
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 144.68,
  y1: 82.68,
  x2: 214.36,
  y2: 91.49
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 192.68,
  y1: 149.46,
  x2: 192.68,
  y2: 57.07
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 200.29,
  y1: 148.72,
  x2: 200.29,
  y2: 58.7
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 207.28,
  y1: 147,
  x2: 207.28,
  y2: 61.2
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 161.53,
  y1: 30.71,
  x2: 161.53,
  y2: 22.83
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 150.25,
  y1: 27.66,
  x2: 150.25,
  y2: 19.37
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 155.98,
  y1: 29.18,
  x2: 155.98,
  y2: 21.3
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 151.4,
  y1: 37.34,
  x2: 151.4,
  y2: 29.05
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 157.12,
  y1: 38.86,
  x2: 157.12,
  y2: 30.98
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 162.68,
  y1: 40.39,
  x2: 162.68,
  y2: 32.51
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 154.07,
  y1: 47.84,
  x2: 154.07,
  y2: 39
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 161.78,
  y1: 49.87,
  x2: 161.78,
  y2: 41.03
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 169.16,
  y1: 51.73,
  x2: 169.16,
  y2: 42.89
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 144.77,
  y1: 22.26,
  x2: 164.88,
  y2: 28.22
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 144.66,
  y1: 32.75,
  x2: 168.32,
  y2: 39.29
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 144.65,
  y1: 43.04,
  x2: 176.45,
  y2: 50.88
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 148.98,
  y1: 18.49,
  x2: 148.98,
  y2: 12.71
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 153.39,
  y1: 19.73,
  x2: 153.39,
  y2: 14.19
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 157.35,
  y1: 21.42,
  x2: 157.35,
  y2: 15.57
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 144.7,
  y1: 15.06,
  x2: 160.84,
  y2: 20.67
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 183.78,
  y1: 109.63,
  x2: 213.32,
  y2: 111.17
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 183.34,
  y1: 119.94,
  x2: 213.96,
  y2: 120.09
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 183.74,
  y1: 130.69,
  x2: 213.51,
  y2: 128.68
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 183.41,
  y1: 141.05,
  x2: 213.28,
  y2: 136.79
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 122.75,
  y1: 96.74,
  x2: 122.75,
  y2: 50.69
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 113.52,
  y1: 97.34,
  x2: 113.52,
  y2: 53.54
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 133.53,
  y1: 95.54,
  x2: 133.53,
  y2: 48.59
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 144.52,
  y1: 58,
  x2: 74.99,
  y2: 71.86
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 144.52,
  y1: 70.19,
  x2: 75.22,
  y2: 81.5
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 144.52,
  y1: 82.68,
  x2: 74.84,
  y2: 91.49
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 96.52,
  y1: 149.46,
  x2: 96.52,
  y2: 57.07
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 88.91,
  y1: 148.72,
  x2: 88.91,
  y2: 58.7
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 81.91,
  y1: 147,
  x2: 81.91,
  y2: 61.2
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 104.69,
  y1: 109.54,
  x2: 75.15,
  y2: 111.07
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 105.13,
  y1: 119.84,
  x2: 74.51,
  y2: 119.99
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 104.72,
  y1: 130.59,
  x2: 74.96,
  y2: 128.58
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 105.05,
  y1: 140.95,
  x2: 75.19,
  y2: 136.69
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 127.67,
  y1: 30.71,
  x2: 127.67,
  y2: 22.83
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 138.95,
  y1: 27.66,
  x2: 138.95,
  y2: 19.37
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 133.22,
  y1: 29.18,
  x2: 133.22,
  y2: 21.3
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 137.8,
  y1: 37.34,
  x2: 137.8,
  y2: 29.05
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 132.08,
  y1: 38.86,
  x2: 132.08,
  y2: 30.98
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 126.52,
  y1: 40.39,
  x2: 126.52,
  y2: 32.51
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 135.13,
  y1: 47.84,
  x2: 135.13,
  y2: 39
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 127.41,
  y1: 49.87,
  x2: 127.41,
  y2: 41.03
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 120.04,
  y1: 51.73,
  x2: 120.04,
  y2: 42.89
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 144.21,
  y1: 22.24,
  x2: 123.03,
  y2: 28.71
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 144.21,
  y1: 32.72,
  x2: 120.62,
  y2: 39.19
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 144.21,
  y1: 43.13,
  x2: 112.96,
  y2: 50.95
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 139.69,
  y1: 18.38,
  x2: 139.69,
  y2: 12.59
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 135.28,
  y1: 19.62,
  x2: 135.28,
  y2: 14.08
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 131.32,
  y1: 21.31,
  x2: 131.32,
  y2: 15.45
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 143.97,
  y1: 14.95,
  x2: 127.83,
  y2: 20.56
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 122.75,
  y1: 96.74,
  x2: 122.75,
  y2: 50.69
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 113.52,
  y1: 97.34,
  x2: 113.52,
  y2: 53.54
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 133.53,
  y1: 95.54,
  x2: 133.53,
  y2: 48.59
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 144.52,
  y1: 58,
  x2: 74.99,
  y2: 71.86
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 144.52,
  y1: 70.19,
  x2: 75.22,
  y2: 81.5
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 144.52,
  y1: 82.68,
  x2: 74.84,
  y2: 91.49
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 96.52,
  y1: 149.46,
  x2: 96.52,
  y2: 57.07
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 88.91,
  y1: 148.72,
  x2: 88.91,
  y2: 58.7
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 81.91,
  y1: 147,
  x2: 81.91,
  y2: 61.2
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 104.69,
  y1: 109.54,
  x2: 75.15,
  y2: 111.07
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 105.13,
  y1: 119.84,
  x2: 74.51,
  y2: 119.99
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 104.72,
  y1: 130.59,
  x2: 74.96,
  y2: 128.58
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 105.05,
  y1: 140.95,
  x2: 75.19,
  y2: 136.69
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 127.67,
  y1: 30.71,
  x2: 127.67,
  y2: 22.83
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 138.95,
  y1: 27.66,
  x2: 138.95,
  y2: 19.37
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 133.22,
  y1: 29.18,
  x2: 133.22,
  y2: 21.3
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 137.8,
  y1: 37.34,
  x2: 137.8,
  y2: 29.05
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 132.08,
  y1: 38.86,
  x2: 132.08,
  y2: 30.98
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 126.52,
  y1: 40.39,
  x2: 126.52,
  y2: 32.51
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 135.13,
  y1: 47.84,
  x2: 135.13,
  y2: 39
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 127.41,
  y1: 49.87,
  x2: 127.41,
  y2: 41.03
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 120.04,
  y1: 51.73,
  x2: 120.04,
  y2: 42.89
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 144.21,
  y1: 22.24,
  x2: 123.03,
  y2: 28.71
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 144.21,
  y1: 32.72,
  x2: 120.62,
  y2: 39.19
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 144.21,
  y1: 43.13,
  x2: 112.96,
  y2: 50.95
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 139.69,
  y1: 18.38,
  x2: 139.69,
  y2: 12.59
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 135.28,
  y1: 19.62,
  x2: 135.28,
  y2: 14.08
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 131.32,
  y1: 21.31,
  x2: 131.32,
  y2: 15.45
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 143.97,
  y1: 14.95,
  x2: 127.83,
  y2: 20.56
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 103.45,
  y: 54.77,
  width: 3,
  height: 96.74
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 181.93,
  y: 54.77,
  width: 3,
  height: 96.74
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "213.27 103.14 144.34 96.63 75.37 103.05 75.09 100.06 144.34 93.62 213.55 100.15 213.27 103.14"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 142.84,
  y: 45.35,
  width: 3,
  height: 50.3
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 104.64,
  y: 98.1,
  width: 78.51,
  height: 3
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M586,347.52l-79.34,0-31.67-5.67.49-85.16,70.93-17.73.36.09,70.5,17.81.2,84.87Zm-78.94-3h78.66l28.75-5.3-.19-80L546.35,242l-67.93,17-.46,80.3Z",
  transform: "translate(-402.01 -195.13)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "177.32 52.97 175.32 52.97 175.32 45.27 144.29 36.97 113.82 45.22 113.82 52.75 111.82 52.75 111.82 43.69 144.28 34.9 177.32 43.74 177.32 52.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "121.65 42.28 119.65 42.28 119.65 32.96 144.28 25.65 169.28 33.01 169.28 42.11 167.28 42.11 167.28 34.51 144.29 27.73 121.65 34.45 121.65 42.28"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "166.67 33.04 164.67 33.04 164.67 24.69 144.29 18.11 123.98 24.75 123.98 32.87 121.98 32.87 121.98 23.29 144.28 16.01 166.67 23.24 166.67 33.04"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 143.29,
  y: 10.57,
  width: 2,
  height: 34.6
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "161.66 22.55 159.66 22.55 159.66 17.46 144.28 11.64 128.58 17.47 128.58 22.55 126.58 22.55 126.58 16.08 144.29 9.5 161.66 16.08 161.66 22.55"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 119.8,
  y1: 151.06,
  x2: 119.8,
  y2: 99.7
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 169.23,
  y1: 151.06,
  x2: 169.23,
  y2: 99.7
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 144.39,
  y1: 116.55,
  x2: 144.35,
  y2: 99.53
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 105.77,
  y1: 116.54,
  x2: 182.61,
  y2: 116.54
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 105.97,
  y1: 137.7,
  x2: 121.26,
  y2: 137.7
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 167.72,
  y1: 137.7,
  x2: 183.01,
  y2: 137.7
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 137.06,
  y1: 127.35,
  x2: 137.06,
  y2: 121.42
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 151.67,
  y1: 127.35,
  x2: 151.67,
  y2: 121.42
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 123.93,
  y: 138.53,
  width: 42.35,
  height: 1.53
}));

function SvgCitIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "cit",
    viewBox: "0 0 288.66 152.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitIllustration);
export default __webpack_public_path__ + "static/media/CIT_Illustration.eeb19c86.svg";
export { ForwardRef as ReactComponent };